import {makeCompositionItems} from "../helpers/composition-items.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeAnimalItems} from "../helpers/animal-items.js";

export default function Compositions({ data, title }) {
    const animals = data?.garrison?.animals ?? "";
    const comp = makeCompositionItems(data);
    const ani = makeAnimalItems(data);

    return (
        <div className="px-5 space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="space-y-2">
                <InfoGrid title="" items={comp} className="px-0!" />
                <InfoGrid title="" items={ani} columns={1} className={`px-0! ${animals ? "" : "hidden"}`} />
            </div>
        </div>
    )
}